import React from "react";
import { Link } from "react-router-dom";
import contact from '../assets/images/solar/conta.webp'
import { FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';

export default function GetInTouch(){
    return(
        <section className="relative lg:py-24 py-16 bg-white dark:bg-slate-900" id="contact">
            <div className="container relative">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="font-semibold text-2xl leading-normal mb-4">Get in touch</h3>
                </div>

                <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
                    <div className="lg:col-span-6 md:col-span-6">
                        <img src={contact} className="rounded-xl shadow-lg" alt="Contact RENERG"/>
                    </div>

                    <div className="lg:col-span-6 md:col-span-6">
                        <div className="lg:ms-5">
                            <div className="bg-white dark:bg-slate-900 rounded-xl shadow-lg dark:shadow-gray-700 p-6 lg:p-8">
                                <h4 className="text-xl font-semibold text-slate-900 dark:text-white mb-6">Contact Information</h4>
                                
                                <div className="space-y-6">
                                    {/* Phone */}
                                    <div className="flex items-start gap-4">
                                        <div className="w-12 h-12 bg-teal-50 dark:bg-teal-900/20 rounded-lg flex items-center justify-center flex-shrink-0">
                                            <FiPhone className="text-teal-600 dark:text-teal-400 text-xl" />
                                        </div>
                                        <div>
                                            <h5 className="font-semibold text-slate-900 dark:text-white mb-1">Phone</h5>
                                            <a href="tel:+250791502063" className="text-slate-600 dark:text-slate-400 hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-200">
                                                +250 791 502 063
                                            </a>
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="flex items-start gap-4">
                                        <div className="w-12 h-12 bg-teal-50 dark:bg-teal-900/20 rounded-lg flex items-center justify-center flex-shrink-0">
                                            <FiMail className="text-teal-600 dark:text-teal-400 text-xl" />
                                        </div>
                                        <div>
                                            <h5 className="font-semibold text-slate-900 dark:text-white mb-1">Email</h5>
                                            <a href="mailto:renergrwanda@gmail.com" className="text-slate-600 dark:text-slate-400 hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-200 break-all">
                                                renergrwanda@gmail.com
                                            </a>
                                        </div>
                                    </div>

                                    {/* Address */}
                                    <div className="flex items-start gap-4">
                                        <div className="w-12 h-12 bg-teal-50 dark:bg-teal-900/20 rounded-lg flex items-center justify-center flex-shrink-0">
                                            <FiMapPin className="text-teal-600 dark:text-teal-400 text-xl" />
                                        </div>
                                        <div>
                                            <h5 className="font-semibold text-slate-900 dark:text-white mb-1">Headquarters</h5>
                                            <p className="text-slate-600 dark:text-slate-400">
                                                Nyarugenge, Kigali<br/>
                                                Rwanda, East Africa
                                            </p>
                                        </div>
                                    </div>

                                    {/* Business Hours */}
                                    <div className="flex items-start gap-4">
                                        <div className="w-12 h-12 bg-teal-50 dark:bg-teal-900/20 rounded-lg flex items-center justify-center flex-shrink-0">
                                            <FiClock className="text-teal-600 dark:text-teal-400 text-xl" />
                                        </div>
                                        <div>
                                            <h5 className="font-semibold text-slate-900 dark:text-white mb-1">Business Hours</h5>
                                            <p className="text-slate-600 dark:text-slate-400">
                                                Monday - Friday: 8:00 AM - 5:00 PM<br/>
                                                Saturday: 9:00 AM - 1:00 PM
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Quick Actions */}
                                <div className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-700">
                                    <div className="flex flex-col sm:flex-row gap-3">
                                        <a 
                                            href="mailto:renergrwanda@gmail.com" 
                                            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-teal-600 hover:bg-teal-700 text-white font-semibold rounded-lg transition-all duration-200"
                                        >
                                            <FiMail className="text-lg" />
                                            Email Us
                                        </a>
                                        <a 
                                            href="tel:+250791502063" 
                                            className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-semibold rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700 transition-all duration-200"
                                        >
                                            <FiPhone className="text-lg" />
                                            Call Now
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}